function handlePromoDisplay() {
  const promoText = document.getElementById('promotion-text-container');
  const mobilePromoText = document.getElementById('promotion-text-container-m');
  if (!promoText && !mobilePromoText) return;
  const checkForPromo = promoText.querySelector('.fs-custom-single-promo');
  const checkForPromoM = mobilePromoText.querySelector('.fs-custom-single-promo');
  if (!checkForPromo || !checkForPromoM) {console.warn('No promo text found'); return;}
  const allApplicablePromos = promoText.querySelectorAll('.fs-custom-single-promo');
  const allApplicableMobilePromos = mobilePromoText.querySelectorAll('.fs-custom-single-promo');
  let activePromoFound = false;

  
  const getCurrentUTCTime = () => {
    const now = new Date();
    return now.toISOString();
  }
  
  const getStartTime = (startTime) => {
    const start = new Date(`${startTime}`);
    return start.toISOString();
  }
  
  const getEndTime = (endTime) => {
    const end = new Date(`${endTime}`);
    return end.toISOString();
  }
  
  const isPromoActive = (start, end, persist) => {
    //debugger;
    if (persist == "true") { return true };
    const currentTime = getCurrentUTCTime();
    const startTime = getStartTime(start);
    const endTime = getEndTime(end);
    let isActive = currentTime >= startTime && currentTime <= endTime? true : false;
    return isActive;
  }

    // Push promo data to LD+JSON
    const pushPromoDataToLDJSON = (activePromo) => {
      const ldJsonElement = document.getElementById('product-ld-json');
      if (!ldJsonElement) return;
    
      const ldJsonData = JSON.parse(ldJsonElement.textContent);
      const promoData = {
        "price": parseFloat(activePromo.getAttribute('data-promo-price').replace('$', '')),
        "priceCurrency": "USD",
        "@type": "UnitPriceSpecification"
      };
    
      if (ldJsonData.offers && Array.isArray(ldJsonData.offers)) {
        ldJsonData.offers.forEach(offer => {
          if (offer.priceSpecification && Array.isArray(offer.priceSpecification)) {
            const exists = offer.priceSpecification.some(spec => 
              spec.price === promoData.price && spec.priceCurrency === promoData.priceCurrency
            );
    
            if (!exists) {
              offer.priceSpecification.push(promoData);
            }
          }
        });
      }
    
      ldJsonElement.textContent = JSON.stringify(ldJsonData, null, 2);
    };

    for (let i = 0; i < allApplicablePromos.length; i++) {
      const currPromo = allApplicablePromos[i];
      const currPromoStart = currPromo.getAttribute('data-start-time');
      const currPromoEnd = currPromo.getAttribute('data-end-time');
      const currPromoPersist = currPromo.getAttribute('data-promo-continue');
      const currPromoInAppOnly = currPromo.getAttribute('data-app-only');
      const currPromoNotInApp = currPromo.getAttribute('data-not-in-app');
      const currPromoUtmParams = currPromo.getAttribute('data-utm-params');

        // Get current URL query parameters
        const urlParams = new URLSearchParams(window.location.search);
        const isInApp = urlParams.get('app') === 'kinn';
  
        // Check app-specific conditions
        if (isInApp && currPromoNotInApp === 'true') continue;
        if (!isInApp && currPromoInAppOnly === 'true') continue;
  
        // Handle UTM parameter validation
        if (currPromoUtmParams) {
          let utmArr = currPromoUtmParams.split(',');
          let hasMatchingUtm = false;
  
          // Check if any UTM combination matches
          for (let utmCombo of utmArr) {
            const utmPairs = utmCombo.split('&');
            const allPairsMatch = utmPairs.every(pair => {
              const [key, value] = pair.trim().split('=');
              return urlParams.get(key) === value;
            });
            
            if (allPairsMatch) {
              hasMatchingUtm = true;
              break;
            }
          }
  
          if (!hasMatchingUtm) continue;
        }


      if (isPromoActive(currPromoStart, currPromoEnd, currPromoPersist)) {
        activePromoFound = true;

        if (window.innerWidth > 768) {
          allApplicablePromos[i].style.display = 'block';
          pushPromoDataToLDJSON(allApplicablePromos[i]);
        } else {
          allApplicableMobilePromos[i].style.display = 'block';
          pushPromoDataToLDJSON(allApplicableMobilePromos[i]);
        }

        break;
      }
    }
};

  document.addEventListener('DOMContentLoaded', () => {
    handlePromoDisplay();

    const quickviewElements = document.querySelectorAll('.product_quickview');

    if (quickviewElements.length === 0) {
      console.warn('No elements with class "product_quickview" found.');
      return; // Exit if no elements are found
    }

  
    // Set up a MutationObserver for each product_quickview element
    quickviewElements.forEach(quickview => {
      //debugger;
      const observer = new MutationObserver(mutations => {
        //debugger;
        mutations.forEach(mutation => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            
            if (quickview.classList.contains('active')) {
              setTimeout(() => {
                handlePromoDisplay();
              }, 300);
            }
          }
        });
      });
  
      observer.observe(quickview, { attributes: true });
    });
  });